import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

import { useSelector } from "react-redux";

import { ENV } from '../../API/config';
import { unoTheme } from '../../assets/styles/unoTheme';
import MyAutoComplete from '../utils/MyAutoComplete';
import UnoButton from '../utils/UnoButton';
import { getClientLabelWithMigrationFlag } from '../utils/utils';

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: theme.spacing(2),
        minWidth: '480px',
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    hint: {
        fontSize: '.85em',
        color: unoTheme.defaultTextColor,
        marginTop: theme.spacing(1),
    },

}));

/**
 * Libera um cliente para relacionar predefinições da Comparação de Fundos a agrupamentos.
 * A listagem vem de state.activeClients, já carregada por consultoria em UnoDashboard.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {array} props.enabledClientsIds clientes já liberados, que saem das opções
 * @param {boolean} props.saving desabilita o 'Adicionar' enquanto grava
 * @param {function} props.handleAdd recebe o cliente escolhido
 * @param {function} props.handleClose
 */
export default function AddFundGroupClientModal({ open, enabledClientsIds, saving, handleAdd, handleClose }) {

    const classes = useStyles();

    const activeClients = useSelector(state => state.activeClients);

    const [selectedClient, setSelectedClient] = useState(null);

    const options = useMemo(() => (activeClients || []).filter(el => !(enabledClientsIds || []).includes(el.id)),
        [activeClients, enabledClientsIds]);

    useEffect(() => {

        if (open) {
            setSelectedClient(null);
        }

    }, [open])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            onClose={() => handleClose()}>

            <DialogTitle>
                {"Adicionar cliente"}
            </DialogTitle>

            <DialogContent className={classes.contentModal}>

                <MyAutoComplete
                    outerlabel={'Cliente'}
                    options={options}
                    autoComplete
                    value={selectedClient}
                    onChange={(event, newValue) => setSelectedClient(newValue)}
                    placeholder={"Selecione o cliente"}
                    getOptionLabel={(option) => (ENV === "DEV" || ENV === "HOMOLOG" ? option.id + " / " : "") + getClientLabelWithMigrationFlag(option)}
                    getOptionSelected={(option, value) => option.id === value.id}
                    renderOption={(option) => (
                        <React.Fragment key={'fund-group-client-' + option.id}>
                            <span>{getClientLabelWithMigrationFlag(option)}</span>
                        </React.Fragment>
                    )}
                />

                <Typography className={classes.hint}>
                    {'O cliente passa a poder relacionar predefinições da Comparação de Fundos a agrupamentos de fundos.'}
                </Typography>

            </DialogContent>

            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() => handleClose()} color="secondary">
                    {'Cancelar'}
                </UnoButton>

                <UnoButton
                    disabled={!selectedClient || saving}
                    onClick={() => handleAdd(selectedClient)}
                    color="primary">
                    {"Adicionar"}
                </UnoButton>

            </DialogActions>

        </Dialog>
    );
}
